import React, { useState, useEffect } from 'react';
import { List, CheckCircle2, XCircle, Clock, Plus, ShieldCheck, Calendar, CarTaxiFront } from 'lucide-react';
import axios from 'axios';
import { cn } from '../utils/cn.js';
import { BookingsTable } from './BookingsTable.js';
import APIENDPOINT from './config.js';
export const Dashboard = () => {
    const [stats, setStats] = useState({ total: 0, pending: 0, approved: 0, rejected: 0, ongoing: 0, assigned: 0, unassigned: 0, self: 0 });
    const [filter, setFilter] = useState('all');

    // Assume current logged in admin ID is 1 for now (or get from your auth state)
    const user = JSON.parse(localStorage.getItem('user'));

    const fetchStats = async () => {
        try {
            const res = await fetch(`${APIENDPOINT}booking.php?action=stats&admin_id=${user.id}`);
            const data = await res.json();
            setStats(data);
        } catch (error) {
            console.error("Error fetching stats:", error);
        }
    };

    useEffect(() => {
        fetchStats();
    }, []);

    const cards = [
        { id: 'all', label: 'Total', value: stats.total, icon: List, color: 'text-blue-600', bg: 'bg-blue-50' },
        { id: 'pending', label: 'Pending', value: stats.pending, icon: Clock, color: 'text-amber-600', bg: 'bg-amber-50' },
        { id: 'approved', label: 'Approved', value: stats.approved, icon: CheckCircle2, color: 'text-emerald-600', bg: 'bg-emerald-50' },
        { id: 'rejected', label: 'Rejected', value: stats.rejected, icon: XCircle, color: 'text-rose-600', bg: 'bg-rose-50' },
        { id: 'assigned', label: 'Assigned', value: stats.assigned, icon: ShieldCheck, color: 'text-indigo-600', bg: 'bg-indigo-50' },
        { id: 'unassigned', label: 'Unassigned', value: stats.unassigned, icon: Plus, color: 'text-orange-600', bg: 'bg-orange-50' },
        { id: 'ongoing', label: 'Today', value: stats.ongoing, icon: Calendar, color: 'text-cyan-600', bg: 'bg-cyan-50' },
        { id: 'self', label: 'My Trips', value: stats.self, icon: CarTaxiFront, color: 'text-purple-600', bg: 'bg-purple-50' },
    ];
    return (
        <div className="space-y-6">
            <h2 className="text-xl md:text-2xl font-bold text-gray-900">Dashboard Overview</h2>

            {/* Grid updated to handle 8 cards: 2 per row on mobile, 4 per row on desktop */}
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-4">
                {cards.map((card) => (
                    <button
                        key={card.id}
                        onClick={() => setFilter(card.id)}
                        className={cn(
                            "p-2 md:p-4 rounded-xl md:rounded-2xl border transition-all text-left flex flex-row md:flex-col items-center md:items-start gap-2 md:gap-3",
                            filter === card.id
                                ? "bg-white border-emerald-500 shadow-md ring-1 ring-emerald-500"
                                : "bg-white border-gray-100 shadow-sm hover:border-gray-200"
                        )}
                    >
                        <div className={cn("p-1.5 md:p-2 rounded-lg flex-shrink-0", card.bg)}>
                            <card.icon className={cn("w-4 h-4 md:w-5 md:h-5", card.color)} />
                        </div>
                        <div className="min-w-0">
                            <p className="text-[9px] md:text-[10px] uppercase tracking-wider font-bold text-gray-500 truncate">
                                {card.label}
                            </p>
                            <p className="text-sm md:text-xl font-bold text-gray-900 leading-tight">
                                {card.value}
                            </p>
                        </div>
                    </button>
                ))}
            </div>

            <div className='my-5 pb-20 md:pb-0'>
                <BookingsTable admin={true} onRefreshStats={fetchStats} filter={filter}  currentAdmin={user} />
            </div>
        </div>
    );
};